import { render, staticRenderFns } from "./UknowUsers.vue?vue&type=template&id=01eafc4b&scoped=true&"
import script from "./UknowUsers.vue?vue&type=script&lang=ts&"
export * from "./UknowUsers.vue?vue&type=script&lang=ts&"
import style0 from "./UknowUsers.vue?vue&type=style&index=0&id=01eafc4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eafc4b",
  null
  
)

export default component.exports